require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-content-type-sandbox-sample-embedded-page-photo-with-overlay.json") })
        }
      }, "path---es-content-type-sandbox-sample-embedded-page-photo-with-overlay");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-content-type-sandbox-sample-embedded-page-photo-with-overlay!./.cache/json/es-content-type-sandbox-sample-embedded-page-photo-with-overlay.json
// module id = 2543
// module chunks = 231608221292675